import { render, staticRenderFns } from "./TaxSpan.vue?vue&type=template&id=e50dce94&"
import script from "./TaxSpan.vue?vue&type=script&lang=js&"
export * from "./TaxSpan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports